module.exports = __webpack_public_path__ + "img/2-ilpakamanicalletemuco_thumb.e66a811a.jpg";